import { render, staticRenderFns } from "./NormalBox.vue?vue&type=template&id=66525ecb&scoped=true"
import script from "./NormalBox.vue?vue&type=script&lang=js"
export * from "./NormalBox.vue?vue&type=script&lang=js"
import style0 from "./NormalBox.vue?vue&type=style&index=0&id=66525ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66525ecb",
  null
  
)

export default component.exports